<h2 mat-dialog-title>Reconhecimento Facial</h2>

<div mat-dialog-content class="body-modal-camera">
    <app-face-capture (webcamStarted)="webcamStarted($event)" (saveImage)="imageResult($event)"
        [allowTakePhoto]="allowTakePhoto"></app-face-capture>
</div>

<div mat-dialog-actions class="0 row">

    <div class="col-md-4">
        <button *ngIf="!takingPhoto && !allowTakePhoto" mat-flat-button color="primary" class="btn-block">
            <span>{{countDownPhoto}}</span>
        </button>
        <button *ngIf="!takingPhoto && allowTakePhoto" (click)="clickReTakePhoto()" mat-flat-button color="accent"
            class="btn-block">
            <span>Tirar Novamente</span>
        </button>
    </div>
    <div class="col-md-4">
        <button *ngIf="!takingPhoto && allowTakePhoto" (click)="saveImage()" mat-flat-button color="primary"
            class="btn-block">
            <span>Usar imagem</span>
        </button>
    </div>
    <div class="col-md-4">
        <button mat-flat-button (click)="close()" color="accent" class="btn-block">
            Cancelar
        </button>
    </div>
</div>